export const TECHNICIAN_MESSAGES = {
  SUCCESS_ADD:
    'Technik został pomyślnie dodany. Wiadomość z tymczasowymi danymi do logowania została wysłana na jego skrzynkę odbiorczą.',
  SUCCESS_EDIT: 'Dane technika zostały zaktualizowane.',
} as const;
